import { EnterpriseReportConstants } from './report.constants';

export const report = (state = {}, action) => {
    switch (action.type) {
        case EnterpriseReportConstants.GET_ALL_ENTERPRISE_REPORT_SUCCESS:
            return {
                ...state,
                ...action.payload
            };

        case EnterpriseReportConstants.ALL_ENTERPRISE_REPORT_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case EnterpriseReportConstants.GET_ALL_ENTERPRISE_REPORT_ERROR:
            return {
                ...state,
                error: true
            };
        case EnterpriseReportConstants.EMPTY_ENTERPRISE_REPORT:
            return {
                ...state,
                data: ""
            };
        default:
            return state;
    }
}